import {countries} from '../helpers/countries';
import { applicantFields, studentNumberFields } from '../helpers/fields';
import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'msgemergencymedical';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
	return {
		dependent_fields: [
			...applicantFields('*', [
				{ value: 'dependent', text: 'Dependent Child' },
				{ value: 'travelling companion', text: 'Travelling Companion' },
				{ value: 'spouse', text: 'Spouse' }
			]
			),
			...studentNumberFields('*')
		],
		coverage_fields: [
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'single trip'
				}, {
					key_path: ['application', 'additional_data', 'additional_coverage'],
					value: true
				}],
				key_path: ['application', 'departure_date'],
				as: 'Departure Date',
				format: 'date'
			},
			{
				key_path: ['application', 'additional_data', 'policy_type'],
				as: 'Policy Type',
				type: 'radio',
				options: [
					{ value: 'single trip', text: 'Single Trip' },
					{ value: 'multi-trip annual', text: 'Multi-Trip Annual' }
				],
				is_static_by_default: true
			},
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'single trip'
				}, {
					key_path: ['application', 'additional_data', 'additional_coverage'],
					value: true
				}],
				key_path: ['application', 'additional_data', 'top_up'],
				as: 'Top Up',
				is_static_by_default: true
			},
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'single trip'
				}, {
					key_path: ['application', 'additional_data', 'additional_coverage'],
					value: true
				}],
				key_path: ['application', 'additional_data', 'days_of_coverage'],
				as: 'Number of days covered by other insurance plan'
			},
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'single trip'
				}, {
					key_path: ['application', 'additional_data', 'additional_coverage'],
					value: true
				}],
				key_path: ['application', 'additional_data', 'additional_coverage_plan'],
				as: 'Name of plan'
			},
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'single trip'
				}],
				key_path: ['application', 'additional_data', 'destination'],
				as: 'Destination',
				type: 'dropdown',
				options: countries(true)
			},
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'multi-trip annual'
				}],
				key_path: ['application', 'additional_data', 'number_of_days_per_trip'],
				as: 'Number of Days per Trip',
				type: 'dropdown',
				options: [
					{ value: 5, text: '5 Days' },
					{ value: 10, text: '10 Days' },
					{ value: 20, text: '20 Days' },
					{ value: 35, text: '35 Days' },
					{ value: 50, text: '50 Days' },
					{ value: 65, text: '65 Days' },
					{ value: 100, text: '100 Days' }

				]
			},
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'single trip'
				}],
				do_not_show_if: [{
					key_path: ['application', 'additional_data', 'destination'],
					value: 'US'
				}, {
					key_path: ['application', 'additional_data', 'destination'],
					value: 'CA'
				}, {
					key_path: ['application', 'additional_data', 'travelling_through_the_us'],
					value: null
				}],
				key_path: ['application', 'additional_data', 'travelling_through_the_us'],
				as: 'Are applicants travelling through the US?',
				type: 'radio',
				options: [
					{ value: 'no', text: 'No' },
					{ value: 'yes', text: 'Yes' }
				]
			},
			{
				show_if: [{
					key_path: ['application', 'additional_data', 'policy_type'],
					value: 'single trip'
				}, {
					key_path: ['application', 'additional_data', 'travelling_through_the_us'],
					value: 'yes'
				}],
				do_not_show_if: [{
					key_path: ['application', 'additional_data', 'destination'],
					value: 'US'
				}],
				key_path: ['application', 'additional_data', 'number_of_travel_days_in_the_us'],
				as: 'Number of Travel Days in the US'
			},
			{
				key_path: ['application', 'additional_data', 'deductible'],
				as: 'Deductible',
				type: 'dropdown',
				options: [
					{ value: 0, text: '$0.00 CAD' },
					{ value: 250, text: '$250.00 CAD' },
					{ value: 500, text: '$500.00 CAD' },
					{ value: 1000, text: '$1,000.00 CAD' },
					{ value: 5000, text: '$5,000.00 CAD' },
					{ value: 10000, text: '$10,000.00 CAD' }
				]
			}
		]
	};
}


// WEBPACK FOOTER //
// ./src/clients/msgemergencymedical.js